export const Languages = {
  languages: [
    {
      LCID: 'ca-AD',
      language_code: 'ca',
      language_name: 'Catalan',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'AD',
      country_name: 'Andorra',
      country_currencies: 'EUR',
      country_capital: 'Andorra la Vella',
    },
    {
      LCID: 'ar-AE',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AE',
      country_name: 'United Arab Emirates',
      country_currencies: 'AED',
      country_capital: 'Abu Dhabi',
    },
    {
      LCID: 'ps-AF',
      language_code: 'ps',
      language_name: 'Pashto',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AF',
      country_name: 'Afghanistan',
      country_currencies: 'AFN',
      country_capital: 'Kabul',
    },
    {
      LCID: 'uz-AF',
      language_code: 'uz',
      language_name: 'Uzbek',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AF',
      country_name: 'Afghanistan',
      country_currencies: 'AFN',
      country_capital: 'Kabul',
    },
    {
      LCID: 'tk-AF',
      language_code: 'tk',
      language_name: 'Turkmen',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AF',
      country_name: 'Afghanistan',
      country_currencies: 'AFN',
      country_capital: 'Kabul',
    },
    {
      LCID: 'en-AG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'AG',
      country_name: 'Antigua and Barbuda',
      country_currencies: 'XCD',
      country_capital: "Saint John's",
    },
    {
      LCID: 'en-AI',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'AI',
      country_name: 'Anguilla',
      country_currencies: 'XCD',
      country_capital: 'The Valley',
    },
    {
      LCID: 'sq-AL',
      language_code: 'sq',
      language_name: 'Albanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'AL',
      country_name: 'Albania',
      country_currencies: 'ALL',
      country_capital: 'Tirana',
    },
    {
      LCID: 'hy-AM',
      language_code: 'hy',
      language_name: 'Armenian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AM',
      country_name: 'Armenia',
      country_currencies: 'AMD',
      country_capital: 'Yerevan',
    },
    {
      LCID: 'ru-AM',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AM',
      country_name: 'Armenia',
      country_currencies: 'AMD',
      country_capital: 'Yerevan',
    },
    {
      LCID: 'pt-AO',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'AO',
      country_name: 'Angola',
      country_currencies: 'AOA',
      country_capital: 'Luanda',
    },
    {
      LCID: 'es-AR',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'AR',
      country_name: 'Argentina',
      country_currencies: 'ARS',
      country_capital: 'Buenos Aires',
    },
    {
      LCID: 'gn-AR',
      language_code: 'gn',
      language_name: 'Guarani',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'AR',
      country_name: 'Argentina',
      country_currencies: 'ARS',
      country_capital: 'Buenos Aires',
    },
    {
      LCID: 'en-AS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'AS',
      country_name: 'American Samoa',
      country_currencies: 'USD',
      country_capital: 'Pago Pago',
    },
    {
      LCID: 'sm-AS',
      language_code: 'sm',
      language_name: 'Samoan',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'AS',
      country_name: 'American Samoa',
      country_currencies: 'USD',
      country_capital: 'Pago Pago',
    },
    {
      LCID: 'de-AT',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'AT',
      country_name: 'Austria',
      country_currencies: 'EUR',
      country_capital: 'Vienna',
    },
    {
      LCID: 'en-AU',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'AU',
      country_name: 'Australia',
      country_currencies: 'AUD',
      country_capital: 'Canberra',
    },
    {
      LCID: 'nl-AW',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'AW',
      country_name: 'Aruba',
      country_currencies: 'AWG',
      country_capital: 'Oranjestad',
    },
    {
      LCID: 'pa-AW',
      language_code: 'pa',
      language_name: 'Panjabi / Punjabi',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'AW',
      country_name: 'Aruba',
      country_currencies: 'AWG',
      country_capital: 'Oranjestad',
    },
    {
      LCID: 'sv-AX',
      language_code: 'sv',
      language_name: 'Swedish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'AX',
      country_name: 'Åland',
      country_currencies: 'EUR',
      country_capital: 'Mariehamn',
    },
    {
      LCID: 'az-AZ',
      language_code: 'az',
      language_name: 'Azerbaijani',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'AZ',
      country_name: 'Azerbaijan',
      country_currencies: 'AZN',
      country_capital: 'Baku',
    },
    {
      LCID: 'bs-BA',
      language_code: 'bs',
      language_name: 'Bosnian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BA',
      country_name: 'Bosnia and Herzegovina',
      country_currencies: 'BAM',
      country_capital: 'Sarajevo',
    },
    {
      LCID: 'hr-BA',
      language_code: 'hr',
      language_name: 'Croatian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BA',
      country_name: 'Bosnia and Herzegovina',
      country_currencies: 'BAM',
      country_capital: 'Sarajevo',
    },
    {
      LCID: 'sr-BA',
      language_code: 'sr',
      language_name: 'Serbian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BA',
      country_name: 'Bosnia and Herzegovina',
      country_currencies: 'BAM',
      country_capital: 'Sarajevo',
    },
    {
      LCID: 'en-BB',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BB',
      country_name: 'Barbados',
      country_currencies: 'BBD',
      country_capital: 'Bridgetown',
    },
    {
      LCID: 'bn-BD',
      language_code: 'bn',
      language_name: 'Bengali',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'BD',
      country_name: 'Bangladesh',
      country_currencies: 'BDT',
      country_capital: 'Dhaka',
    },
    {
      LCID: 'nl-BE',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BE',
      country_name: 'Belgium',
      country_currencies: 'EUR',
      country_capital: 'Brussels',
    },
    {
      LCID: 'fr-BE',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BE',
      country_name: 'Belgium',
      country_currencies: 'EUR',
      country_capital: 'Brussels',
    },
    {
      LCID: 'de-BE',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BE',
      country_name: 'Belgium',
      country_currencies: 'EUR',
      country_capital: 'Brussels',
    },
    {
      LCID: 'fr-BF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BF',
      country_name: 'Burkina Faso',
      country_currencies: 'XOF',
      country_capital: 'Ouagadougou',
    },
    {
      LCID: 'ff-BF',
      language_code: 'ff',
      language_name: 'Peul',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BF',
      country_name: 'Burkina Faso',
      country_currencies: 'XOF',
      country_capital: 'Ouagadougou',
    },
    {
      LCID: 'bg-BG',
      language_code: 'bg',
      language_name: 'Bulgarian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BG',
      country_name: 'Bulgaria',
      country_currencies: 'BGN',
      country_capital: 'Sofia',
    },
    {
      LCID: 'ar-BH',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'BH',
      country_name: 'Bahrain',
      country_currencies: 'BHD',
      country_capital: 'Manama',
    },
    {
      LCID: 'fr-BI',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BI',
      country_name: 'Burundi',
      country_currencies: 'BIF',
      country_capital: 'Bujumbura',
    },
    {
      LCID: 'rn-BI',
      language_code: 'rn',
      language_name: 'Kirundi',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BI',
      country_name: 'Burundi',
      country_currencies: 'BIF',
      country_capital: 'Bujumbura',
    },
    {
      LCID: 'fr-BJ',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BJ',
      country_name: 'Benin',
      country_currencies: 'XOF',
      country_capital: 'Porto-Novo',
    },
    {
      LCID: 'fr-BL',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BL',
      country_name: 'Saint Barthélemy',
      country_currencies: 'EUR',
      country_capital: 'Gustavia',
    },
    {
      LCID: 'en-BM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BM',
      country_name: 'Bermuda',
      country_currencies: 'BMD',
      country_capital: 'Hamilton',
    },
    {
      LCID: 'ms-BN',
      language_code: 'ms',
      language_name: 'Malay',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'BN',
      country_name: 'Brunei',
      country_currencies: 'BND',
      country_capital: 'Bandar Seri Begawan',
    },
    {
      LCID: 'es-BO',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'BO',
      country_name: 'Bolivia',
      country_currencies: 'BOB,BOV',
      country_capital: 'Sucre',
    },
    {
      LCID: 'ay-BO',
      language_code: 'ay',
      language_name: 'Aymara',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'BO',
      country_name: 'Bolivia',
      country_currencies: 'BOB,BOV',
      country_capital: 'Sucre',
    },
    {
      LCID: 'qu-BO',
      language_code: 'qu',
      language_name: 'Quechua',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'BO',
      country_name: 'Bolivia',
      country_currencies: 'BOB,BOV',
      country_capital: 'Sucre',
    },
    {
      LCID: 'nl-BQ',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BQ',
      country_name: 'Bonaire',
      country_currencies: 'USD',
      country_capital: 'Kralendijk',
    },
    {
      LCID: 'pt-BR',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'BR',
      country_name: 'Brazil',
      country_currencies: 'BRL',
      country_capital: 'Brasília',
    },
    {
      LCID: 'en-BS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BS',
      country_name: 'Bahamas',
      country_currencies: 'BSD',
      country_capital: 'Nassau',
    },
    {
      LCID: 'dz-BT',
      language_code: 'dz',
      language_name: 'Dzongkha',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'BT',
      country_name: 'Bhutan',
      country_currencies: 'BTN,INR',
      country_capital: 'Thimphu',
    },
    {
      LCID: 'no-BV',
      language_code: 'no',
      language_name: 'Norwegian',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'BV',
      country_name: 'Bouvet Island',
      country_currencies: 'NOK',
      country_capital: '',
    },
    {
      LCID: 'nb-BV',
      language_code: 'nb',
      language_name: 'Norwegian Bokmål',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'BV',
      country_name: 'Bouvet Island',
      country_currencies: 'NOK',
      country_capital: '',
    },
    {
      LCID: 'nn-BV',
      language_code: 'nn',
      language_name: 'Norwegian Nynorsk',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'BV',
      country_name: 'Bouvet Island',
      country_currencies: 'NOK',
      country_capital: '',
    },
    {
      LCID: 'en-BW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BW',
      country_name: 'Botswana',
      country_currencies: 'BWP',
      country_capital: 'Gaborone',
    },
    {
      LCID: 'tn-BW',
      language_code: 'tn',
      language_name: 'Tswana',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'BW',
      country_name: 'Botswana',
      country_currencies: 'BWP',
      country_capital: 'Gaborone',
    },
    {
      LCID: 'be-BY',
      language_code: 'be',
      language_name: 'Belarusian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BY',
      country_name: 'Belarus',
      country_currencies: 'BYN',
      country_capital: 'Minsk',
    },
    {
      LCID: 'ru-BY',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'BY',
      country_name: 'Belarus',
      country_currencies: 'BYN',
      country_capital: 'Minsk',
    },
    {
      LCID: 'en-BZ',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BZ',
      country_name: 'Belize',
      country_currencies: 'BZD',
      country_capital: 'Belmopan',
    },
    {
      LCID: 'es-BZ',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'BZ',
      country_name: 'Belize',
      country_currencies: 'BZD',
      country_capital: 'Belmopan',
    },
    {
      LCID: 'en-CA',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CA',
      country_name: 'Canada',
      country_currencies: 'CAD',
      country_capital: 'Ottawa',
    },
    {
      LCID: 'fr-CA',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CA',
      country_name: 'Canada',
      country_currencies: 'CAD',
      country_capital: 'Ottawa',
    },
    {
      LCID: 'en-CC',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'CC',
      country_name: 'Cocos [Keeling] Islands',
      country_currencies: 'AUD',
      country_capital: 'West Island',
    },
    {
      LCID: 'fr-CD',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CD',
      country_name: 'Democratic Republic of the Congo',
      country_currencies: 'CDF',
      country_capital: 'Kinshasa',
    },
    {
      LCID: 'ln-CD',
      language_code: 'ln',
      language_name: 'Lingala',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CD',
      country_name: 'Democratic Republic of the Congo',
      country_currencies: 'CDF',
      country_capital: 'Kinshasa',
    },
    {
      LCID: 'kg-CD',
      language_code: 'kg',
      language_name: 'Kongo',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CD',
      country_name: 'Democratic Republic of the Congo',
      country_currencies: 'CDF',
      country_capital: 'Kinshasa',
    },
    {
      LCID: 'sw-CD',
      language_code: 'sw',
      language_name: 'Swahili',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CD',
      country_name: 'Democratic Republic of the Congo',
      country_currencies: 'CDF',
      country_capital: 'Kinshasa',
    },
    {
      LCID: 'lu-CD',
      language_code: 'lu',
      language_name: 'Luba-Katanga',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CD',
      country_name: 'Democratic Republic of the Congo',
      country_currencies: 'CDF',
      country_capital: 'Kinshasa',
    },
    {
      LCID: 'fr-CF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CF',
      country_name: 'Central African Republic',
      country_currencies: 'XAF',
      country_capital: 'Bangui',
    },
    {
      LCID: 'sg-CF',
      language_code: 'sg',
      language_name: 'Sango',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CF',
      country_name: 'Central African Republic',
      country_currencies: 'XAF',
      country_capital: 'Bangui',
    },
    {
      LCID: 'fr-CG',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CG',
      country_name: 'Republic of the Congo',
      country_currencies: 'XAF',
      country_capital: 'Brazzaville',
    },
    {
      LCID: 'ln-CG',
      language_code: 'ln',
      language_name: 'Lingala',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CG',
      country_name: 'Republic of the Congo',
      country_currencies: 'XAF',
      country_capital: 'Brazzaville',
    },
    {
      LCID: 'de-CH',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CH',
      country_name: 'Switzerland',
      country_currencies: 'CHE,CHF,CHW',
      country_capital: 'Bern',
    },
    {
      LCID: 'fr-CH',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CH',
      country_name: 'Switzerland',
      country_currencies: 'CHE,CHF,CHW',
      country_capital: 'Bern',
    },
    {
      LCID: 'it-CH',
      language_code: 'it',
      language_name: 'Italian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CH',
      country_name: 'Switzerland',
      country_currencies: 'CHE,CHF,CHW',
      country_capital: 'Bern',
    },
    {
      LCID: 'fr-CI',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CI',
      country_name: 'Ivory Coast',
      country_currencies: 'XOF',
      country_capital: 'Yamoussoukro',
    },
    {
      LCID: 'en-CK',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'CK',
      country_name: 'Cook Islands',
      country_currencies: 'NZD',
      country_capital: 'Avarua',
    },
    {
      LCID: 'es-CL',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'CL',
      country_name: 'Chile',
      country_currencies: 'CLF,CLP',
      country_capital: 'Santiago',
    },
    {
      LCID: 'en-CM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CM',
      country_name: 'Cameroon',
      country_currencies: 'XAF',
      country_capital: 'Yaoundé',
    },
    {
      LCID: 'fr-CM',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CM',
      country_name: 'Cameroon',
      country_currencies: 'XAF',
      country_capital: 'Yaoundé',
    },
    {
      LCID: 'zh-CN',
      language_code: 'zh',
      language_name: 'Chinese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'CN',
      country_name: 'China',
      country_currencies: 'CNY',
      country_capital: 'Beijing',
    },
    {
      LCID: 'es-CO',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'CO',
      country_name: 'Colombia',
      country_currencies: 'COP',
      country_capital: 'Bogotá',
    },
    {
      LCID: 'es-CR',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CR',
      country_name: 'Costa Rica',
      country_currencies: 'CRC',
      country_capital: 'San José',
    },
    {
      LCID: 'es-CU',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CU',
      country_name: 'Cuba',
      country_currencies: 'CUC,CUP',
      country_capital: 'Havana',
    },
    {
      LCID: 'pt-CV',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'CV',
      country_name: 'Cape Verde',
      country_currencies: 'CVE',
      country_capital: 'Praia',
    },
    {
      LCID: 'nl-CW',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CW',
      country_name: 'Curacao',
      country_currencies: 'ANG',
      country_capital: 'Willemstad',
    },
    {
      LCID: 'pa-CW',
      language_code: 'pa',
      language_name: 'Panjabi / Punjabi',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CW',
      country_name: 'Curacao',
      country_currencies: 'ANG',
      country_capital: 'Willemstad',
    },
    {
      LCID: 'en-CW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'CW',
      country_name: 'Curacao',
      country_currencies: 'ANG',
      country_capital: 'Willemstad',
    },
    {
      LCID: 'en-CX',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'CX',
      country_name: 'Christmas Island',
      country_currencies: 'AUD',
      country_capital: 'Flying Fish Cove',
    },
    {
      LCID: 'el-CY',
      language_code: 'el',
      language_name: 'Greek',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CY',
      country_name: 'Cyprus',
      country_currencies: 'EUR',
      country_capital: 'Nicosia',
    },
    {
      LCID: 'tr-CY',
      language_code: 'tr',
      language_name: 'Turkish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CY',
      country_name: 'Cyprus',
      country_currencies: 'EUR',
      country_capital: 'Nicosia',
    },
    {
      LCID: 'hy-CY',
      language_code: 'hy',
      language_name: 'Armenian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CY',
      country_name: 'Cyprus',
      country_currencies: 'EUR',
      country_capital: 'Nicosia',
    },
    {
      LCID: 'cs-CZ',
      language_code: 'cs',
      language_name: 'Czech',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CZ',
      country_name: 'Czech Republic',
      country_currencies: 'CZK',
      country_capital: 'Prague',
    },
    {
      LCID: 'sk-CZ',
      language_code: 'sk',
      language_name: 'Slovak',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'CZ',
      country_name: 'Czech Republic',
      country_currencies: 'CZK',
      country_capital: 'Prague',
    },
    {
      LCID: 'de-DE',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'DE',
      country_name: 'Germany',
      country_currencies: 'EUR',
      country_capital: 'Berlin',
    },
    {
      LCID: 'fr-DJ',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'DJ',
      country_name: 'Djibouti',
      country_currencies: 'DJF',
      country_capital: 'Djibouti',
    },
    {
      LCID: 'ar-DJ',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'DJ',
      country_name: 'Djibouti',
      country_currencies: 'DJF',
      country_capital: 'Djibouti',
    },
    {
      LCID: 'da-DK',
      language_code: 'da',
      language_name: 'Danish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'DK',
      country_name: 'Denmark',
      country_currencies: 'DKK',
      country_capital: 'Copenhagen',
    },
    {
      LCID: 'en-DM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'DM',
      country_name: 'Dominica',
      country_currencies: 'XCD',
      country_capital: 'Roseau',
    },
    {
      LCID: 'es-DO',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'DO',
      country_name: 'Dominican Republic',
      country_currencies: 'DOP',
      country_capital: 'Santo Domingo',
    },
    {
      LCID: 'ar-DZ',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'DZ',
      country_name: 'Algeria',
      country_currencies: 'DZD',
      country_capital: 'Algiers',
    },
    {
      LCID: 'es-EC',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'EC',
      country_name: 'Ecuador',
      country_currencies: 'USD',
      country_capital: 'Quito',
    },
    {
      LCID: 'et-EE',
      language_code: 'et',
      language_name: 'Estonian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'EE',
      country_name: 'Estonia',
      country_currencies: 'EUR',
      country_capital: 'Tallinn',
    },
    {
      LCID: 'ar-EG',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'EG',
      country_name: 'Egypt',
      country_currencies: 'EGP',
      country_capital: 'Cairo',
    },
    {
      LCID: 'es-EH',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'EH',
      country_name: 'Western Sahara',
      country_currencies: 'MAD,DZD,MRU',
      country_capital: 'El Aaiún',
    },
    {
      LCID: 'ti-ER',
      language_code: 'ti',
      language_name: 'Tigrinya',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ER',
      country_name: 'Eritrea',
      country_currencies: 'ERN',
      country_capital: 'Asmara',
    },
    {
      LCID: 'ar-ER',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ER',
      country_name: 'Eritrea',
      country_currencies: 'ERN',
      country_capital: 'Asmara',
    },
    {
      LCID: 'en-ER',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ER',
      country_name: 'Eritrea',
      country_currencies: 'ERN',
      country_capital: 'Asmara',
    },
    {
      LCID: 'es-ES',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ES',
      country_name: 'Spain',
      country_currencies: 'EUR',
      country_capital: 'Madrid',
    },
    {
      LCID: 'eu-ES',
      language_code: 'eu',
      language_name: 'Basque',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ES',
      country_name: 'Spain',
      country_currencies: 'EUR',
      country_capital: 'Madrid',
    },
    {
      LCID: 'ca-ES',
      language_code: 'ca',
      language_name: 'Catalan',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ES',
      country_name: 'Spain',
      country_currencies: 'EUR',
      country_capital: 'Madrid',
    },
    {
      LCID: 'gl-ES',
      language_code: 'gl',
      language_name: 'Galician',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ES',
      country_name: 'Spain',
      country_currencies: 'EUR',
      country_capital: 'Madrid',
    },
    {
      LCID: 'oc-ES',
      language_code: 'oc',
      language_name: 'Occitan',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ES',
      country_name: 'Spain',
      country_currencies: 'EUR',
      country_capital: 'Madrid',
    },
    {
      LCID: 'am-ET',
      language_code: 'am',
      language_name: 'Amharic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ET',
      country_name: 'Ethiopia',
      country_currencies: 'ETB',
      country_capital: 'Addis Ababa',
    },
    {
      LCID: 'fi-FI',
      language_code: 'fi',
      language_name: 'Finnish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'FI',
      country_name: 'Finland',
      country_currencies: 'EUR',
      country_capital: 'Helsinki',
    },
    {
      LCID: 'sv-FI',
      language_code: 'sv',
      language_name: 'Swedish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'FI',
      country_name: 'Finland',
      country_currencies: 'EUR',
      country_capital: 'Helsinki',
    },
    {
      LCID: 'en-FJ',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'FJ',
      country_name: 'Fiji',
      country_currencies: 'FJD',
      country_capital: 'Suva',
    },
    {
      LCID: 'fj-FJ',
      language_code: 'fj',
      language_name: 'Fijian',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'FJ',
      country_name: 'Fiji',
      country_currencies: 'FJD',
      country_capital: 'Suva',
    },
    {
      LCID: 'hi-FJ',
      language_code: 'hi',
      language_name: 'Hindi',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'FJ',
      country_name: 'Fiji',
      country_currencies: 'FJD',
      country_capital: 'Suva',
    },
    {
      LCID: 'ur-FJ',
      language_code: 'ur',
      language_name: 'Urdu',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'FJ',
      country_name: 'Fiji',
      country_currencies: 'FJD',
      country_capital: 'Suva',
    },
    {
      LCID: 'en-FK',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'FK',
      country_name: 'Falkland Islands',
      country_currencies: 'FKP',
      country_capital: 'Stanley',
    },
    {
      LCID: 'en-FM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'FM',
      country_name: 'Micronesia',
      country_currencies: 'USD',
      country_capital: 'Palikir',
    },
    {
      LCID: 'fo-FO',
      language_code: 'fo',
      language_name: 'Faroese',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'FO',
      country_name: 'Faroe Islands',
      country_currencies: 'DKK',
      country_capital: 'Tórshavn',
    },
    {
      LCID: 'fr-FR',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'FR',
      country_name: 'France',
      country_currencies: 'EUR',
      country_capital: 'Paris',
    },
    {
      LCID: 'fr-GA',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GA',
      country_name: 'Gabon',
      country_currencies: 'XAF',
      country_capital: 'Libreville',
    },
    {
      LCID: 'en-GB',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'GB',
      country_name: 'United Kingdom',
      country_currencies: 'GBP',
      country_capital: 'London',
    },
    {
      LCID: 'en-GD',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'GD',
      country_name: 'Grenada',
      country_currencies: 'XCD',
      country_capital: "St. George's",
    },
    {
      LCID: 'ka-GE',
      language_code: 'ka',
      language_name: 'Georgian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'GE',
      country_name: 'Georgia',
      country_currencies: 'GEL',
      country_capital: 'Tbilisi',
    },
    {
      LCID: 'fr-GF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'GF',
      country_name: 'French Guiana',
      country_currencies: 'EUR',
      country_capital: 'Cayenne',
    },
    {
      LCID: 'en-GG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'GG',
      country_name: 'Guernsey',
      country_currencies: 'GBP',
      country_capital: 'St. Peter Port',
    },
    {
      LCID: 'fr-GG',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'GG',
      country_name: 'Guernsey',
      country_currencies: 'GBP',
      country_capital: 'St. Peter Port',
    },
    {
      LCID: 'en-GH',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GH',
      country_name: 'Ghana',
      country_currencies: 'GHS',
      country_capital: 'Accra',
    },
    {
      LCID: 'en-GI',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'GI',
      country_name: 'Gibraltar',
      country_currencies: 'GIP',
      country_capital: 'Gibraltar',
    },
    {
      LCID: 'kl-GL',
      language_code: 'kl',
      language_name: 'Greenlandic',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'GL',
      country_name: 'Greenland',
      country_currencies: 'DKK',
      country_capital: 'Nuuk',
    },
    {
      LCID: 'en-GM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GM',
      country_name: 'Gambia',
      country_currencies: 'GMD',
      country_capital: 'Banjul',
    },
    {
      LCID: 'fr-GN',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GN',
      country_name: 'Guinea',
      country_currencies: 'GNF',
      country_capital: 'Conakry',
    },
    {
      LCID: 'ff-GN',
      language_code: 'ff',
      language_name: 'Peul',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GN',
      country_name: 'Guinea',
      country_currencies: 'GNF',
      country_capital: 'Conakry',
    },
    {
      LCID: 'fr-GP',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'GP',
      country_name: 'Guadeloupe',
      country_currencies: 'EUR',
      country_capital: 'Basse-Terre',
    },
    {
      LCID: 'es-GQ',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GQ',
      country_name: 'Equatorial Guinea',
      country_currencies: 'XAF',
      country_capital: 'Malabo',
    },
    {
      LCID: 'fr-GQ',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GQ',
      country_name: 'Equatorial Guinea',
      country_currencies: 'XAF',
      country_capital: 'Malabo',
    },
    {
      LCID: 'el-GR',
      language_code: 'el',
      language_name: 'Greek',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'GR',
      country_name: 'Greece',
      country_currencies: 'EUR',
      country_capital: 'Athens',
    },
    {
      LCID: 'en-GS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'GS',
      country_name: 'South Georgia and the South Sandwich Islands',
      country_currencies: 'GBP',
      country_capital: 'King Edward Point',
    },
    {
      LCID: 'es-GT',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'GT',
      country_name: 'Guatemala',
      country_currencies: 'GTQ',
      country_capital: 'Guatemala City',
    },
    {
      LCID: 'en-GU',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'GU',
      country_name: 'Guam',
      country_currencies: 'USD',
      country_capital: 'Hagåtña',
    },
    {
      LCID: 'ch-GU',
      language_code: 'ch',
      language_name: 'Chamorro',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'GU',
      country_name: 'Guam',
      country_currencies: 'USD',
      country_capital: 'Hagåtña',
    },
    {
      LCID: 'es-GU',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'GU',
      country_name: 'Guam',
      country_currencies: 'USD',
      country_capital: 'Hagåtña',
    },
    {
      LCID: 'pt-GW',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'GW',
      country_name: 'Guinea-Bissau',
      country_currencies: 'XOF',
      country_capital: 'Bissau',
    },
    {
      LCID: 'en-GY',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'GY',
      country_name: 'Guyana',
      country_currencies: 'GYD',
      country_capital: 'Georgetown',
    },
    {
      LCID: 'zh-HK',
      language_code: 'zh',
      language_name: 'Chinese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'HK',
      country_name: 'Hong Kong',
      country_currencies: 'HKD',
      country_capital: 'City of Victoria',
    },
    {
      LCID: 'en-HK',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'HK',
      country_name: 'Hong Kong',
      country_currencies: 'HKD',
      country_capital: 'City of Victoria',
    },
    {
      LCID: 'en-HM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'HM',
      country_name: 'Heard Island and McDonald Islands',
      country_currencies: 'AUD',
      country_capital: '',
    },
    {
      LCID: 'es-HN',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'HN',
      country_name: 'Honduras',
      country_currencies: 'HNL',
      country_capital: 'Tegucigalpa',
    },
    {
      LCID: 'hr-HR',
      language_code: 'hr',
      language_name: 'Croatian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'HR',
      country_name: 'Croatia',
      country_currencies: 'HRK',
      country_capital: 'Zagreb',
    },
    {
      LCID: 'fr-HT',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'HT',
      country_name: 'Haiti',
      country_currencies: 'HTG,USD',
      country_capital: 'Port-au-Prince',
    },
    {
      LCID: 'ht-HT',
      language_code: 'ht',
      language_name: 'Haitian',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'HT',
      country_name: 'Haiti',
      country_currencies: 'HTG,USD',
      country_capital: 'Port-au-Prince',
    },
    {
      LCID: 'hu-HU',
      language_code: 'hu',
      language_name: 'Hungarian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'HU',
      country_name: 'Hungary',
      country_currencies: 'HUF',
      country_capital: 'Budapest',
    },
    {
      LCID: 'id-ID',
      language_code: 'id',
      language_name: 'Indonesian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'ID',
      country_name: 'Indonesia',
      country_currencies: 'IDR',
      country_capital: 'Jakarta',
    },
    {
      LCID: 'ga-IE',
      language_code: 'ga',
      language_name: 'Irish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IE',
      country_name: 'Ireland',
      country_currencies: 'EUR',
      country_capital: 'Dublin',
    },
    {
      LCID: 'en-IE',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IE',
      country_name: 'Ireland',
      country_currencies: 'EUR',
      country_capital: 'Dublin',
    },
    {
      LCID: 'he-IL',
      language_code: 'he',
      language_name: 'Hebrew',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IL',
      country_name: 'Israel',
      country_currencies: 'ILS',
      country_capital: 'Jerusalem',
    },
    {
      LCID: 'ar-IL',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IL',
      country_name: 'Israel',
      country_currencies: 'ILS',
      country_capital: 'Jerusalem',
    },
    {
      LCID: 'en-IM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IM',
      country_name: 'Isle of Man',
      country_currencies: 'GBP',
      country_capital: 'Douglas',
    },
    {
      LCID: 'gv-IM',
      language_code: 'gv',
      language_name: 'Manx',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IM',
      country_name: 'Isle of Man',
      country_currencies: 'GBP',
      country_capital: 'Douglas',
    },
    {
      LCID: 'hi-IN',
      language_code: 'hi',
      language_name: 'Hindi',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IN',
      country_name: 'India',
      country_currencies: 'INR',
      country_capital: 'New Delhi',
    },
    {
      LCID: 'en-IN',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IN',
      country_name: 'India',
      country_currencies: 'INR',
      country_capital: 'New Delhi',
    },
    {
      LCID: 'en-IO',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IO',
      country_name: 'British Indian Ocean Territory',
      country_currencies: 'USD',
      country_capital: 'Diego Garcia',
    },
    {
      LCID: 'ar-IQ',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IQ',
      country_name: 'Iraq',
      country_currencies: 'IQD',
      country_capital: 'Baghdad',
    },
    {
      LCID: 'ku-IQ',
      language_code: 'ku',
      language_name: 'Kurdish',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IQ',
      country_name: 'Iraq',
      country_currencies: 'IQD',
      country_capital: 'Baghdad',
    },
    {
      LCID: 'fa-IR',
      language_code: 'fa',
      language_name: 'Persian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'IR',
      country_name: 'Iran',
      country_currencies: 'IRR',
      country_capital: 'Tehran',
    },
    {
      LCID: 'is-IS',
      language_code: 'is',
      language_name: 'Icelandic',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IS',
      country_name: 'Iceland',
      country_currencies: 'ISK',
      country_capital: 'Reykjavik',
    },
    {
      LCID: 'it-IT',
      language_code: 'it',
      language_name: 'Italian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'IT',
      country_name: 'Italy',
      country_currencies: 'EUR',
      country_capital: 'Rome',
    },
    {
      LCID: 'en-JE',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'JE',
      country_name: 'Jersey',
      country_currencies: 'GBP',
      country_capital: 'Saint Helier',
    },
    {
      LCID: 'fr-JE',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'JE',
      country_name: 'Jersey',
      country_currencies: 'GBP',
      country_capital: 'Saint Helier',
    },
    {
      LCID: 'en-JM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'JM',
      country_name: 'Jamaica',
      country_currencies: 'JMD',
      country_capital: 'Kingston',
    },
    {
      LCID: 'ar-JO',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'JO',
      country_name: 'Jordan',
      country_currencies: 'JOD',
      country_capital: 'Amman',
    },
    {
      LCID: 'ja-JP',
      language_code: 'ja',
      language_name: 'Japanese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'JP',
      country_name: 'Japan',
      country_currencies: 'JPY',
      country_capital: 'Tokyo',
    },
    {
      LCID: 'en-KE',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'KE',
      country_name: 'Kenya',
      country_currencies: 'KES',
      country_capital: 'Nairobi',
    },
    {
      LCID: 'sw-KE',
      language_code: 'sw',
      language_name: 'Swahili',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'KE',
      country_name: 'Kenya',
      country_currencies: 'KES',
      country_capital: 'Nairobi',
    },
    {
      LCID: 'ky-KG',
      language_code: 'ky',
      language_name: 'Kyrgyz',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KG',
      country_name: 'Kyrgyzstan',
      country_currencies: 'KGS',
      country_capital: 'Bishkek',
    },
    {
      LCID: 'ru-KG',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KG',
      country_name: 'Kyrgyzstan',
      country_currencies: 'KGS',
      country_capital: 'Bishkek',
    },
    {
      LCID: 'km-KH',
      language_code: 'km',
      language_name: 'Cambodian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KH',
      country_name: 'Cambodia',
      country_currencies: 'KHR',
      country_capital: 'Phnom Penh',
    },
    {
      LCID: 'en-KI',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'KI',
      country_name: 'Kiribati',
      country_currencies: 'AUD',
      country_capital: 'South Tarawa',
    },
    {
      LCID: 'ar-KM',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'KM',
      country_name: 'Comoros',
      country_currencies: 'KMF',
      country_capital: 'Moroni',
    },
    {
      LCID: 'fr-KM',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'KM',
      country_name: 'Comoros',
      country_currencies: 'KMF',
      country_capital: 'Moroni',
    },
    {
      LCID: 'en-KN',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'KN',
      country_name: 'Saint Kitts and Nevis',
      country_currencies: 'XCD',
      country_capital: 'Basseterre',
    },
    {
      LCID: 'ko-KP',
      language_code: 'ko',
      language_name: 'Korean',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KP',
      country_name: 'North Korea',
      country_currencies: 'KPW',
      country_capital: 'Pyongyang',
    },
    {
      LCID: 'ko-KR',
      language_code: 'ko',
      language_name: 'Korean',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KR',
      country_name: 'South Korea',
      country_currencies: 'KRW',
      country_capital: 'Seoul',
    },
    {
      LCID: 'ar-KW',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KW',
      country_name: 'Kuwait',
      country_currencies: 'KWD',
      country_capital: 'Kuwait City',
    },
    {
      LCID: 'en-KY',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'KY',
      country_name: 'Cayman Islands',
      country_currencies: 'KYD',
      country_capital: 'George Town',
    },
    {
      LCID: 'kk-KZ',
      language_code: 'kk',
      language_name: 'Kazakh',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KZ',
      country_name: 'Kazakhstan',
      country_currencies: 'KZT',
      country_capital: 'Astana',
    },
    {
      LCID: 'ru-KZ',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'KZ',
      country_name: 'Kazakhstan',
      country_currencies: 'KZT',
      country_capital: 'Astana',
    },
    {
      LCID: 'lo-LA',
      language_code: 'lo',
      language_name: 'Laotian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'LA',
      country_name: 'Laos',
      country_currencies: 'LAK',
      country_capital: 'Vientiane',
    },
    {
      LCID: 'ar-LB',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'LB',
      country_name: 'Lebanon',
      country_currencies: 'LBP',
      country_capital: 'Beirut',
    },
    {
      LCID: 'fr-LB',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'LB',
      country_name: 'Lebanon',
      country_currencies: 'LBP',
      country_capital: 'Beirut',
    },
    {
      LCID: 'en-LC',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'LC',
      country_name: 'Saint Lucia',
      country_currencies: 'XCD',
      country_capital: 'Castries',
    },
    {
      LCID: 'de-LI',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LI',
      country_name: 'Liechtenstein',
      country_currencies: 'CHF',
      country_capital: 'Vaduz',
    },
    {
      LCID: 'si-LK',
      language_code: 'si',
      language_name: 'Sinhalese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'LK',
      country_name: 'Sri Lanka',
      country_currencies: 'LKR',
      country_capital: 'Colombo',
    },
    {
      LCID: 'ta-LK',
      language_code: 'ta',
      language_name: 'Tamil',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'LK',
      country_name: 'Sri Lanka',
      country_currencies: 'LKR',
      country_capital: 'Colombo',
    },
    {
      LCID: 'en-LR',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'LR',
      country_name: 'Liberia',
      country_currencies: 'LRD',
      country_capital: 'Monrovia',
    },
    {
      LCID: 'en-LS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'LS',
      country_name: 'Lesotho',
      country_currencies: 'LSL,ZAR',
      country_capital: 'Maseru',
    },
    {
      LCID: 'st-LS',
      language_code: 'st',
      language_name: 'Southern Sotho',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'LS',
      country_name: 'Lesotho',
      country_currencies: 'LSL,ZAR',
      country_capital: 'Maseru',
    },
    {
      LCID: 'lt-LT',
      language_code: 'lt',
      language_name: 'Lithuanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LT',
      country_name: 'Lithuania',
      country_currencies: 'EUR',
      country_capital: 'Vilnius',
    },
    {
      LCID: 'fr-LU',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LU',
      country_name: 'Luxembourg',
      country_currencies: 'EUR',
      country_capital: 'Luxembourg',
    },
    {
      LCID: 'de-LU',
      language_code: 'de',
      language_name: 'German',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LU',
      country_name: 'Luxembourg',
      country_currencies: 'EUR',
      country_capital: 'Luxembourg',
    },
    {
      LCID: 'lb-LU',
      language_code: 'lb',
      language_name: 'Luxembourgish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LU',
      country_name: 'Luxembourg',
      country_currencies: 'EUR',
      country_capital: 'Luxembourg',
    },
    {
      LCID: 'lv-LV',
      language_code: 'lv',
      language_name: 'Latvian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'LV',
      country_name: 'Latvia',
      country_currencies: 'EUR',
      country_capital: 'Riga',
    },
    {
      LCID: 'ar-LY',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'LY',
      country_name: 'Libya',
      country_currencies: 'LYD',
      country_capital: 'Tripoli',
    },
    {
      LCID: 'ar-MA',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MA',
      country_name: 'Morocco',
      country_currencies: 'MAD',
      country_capital: 'Rabat',
    },
    {
      LCID: 'fr-MC',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'MC',
      country_name: 'Monaco',
      country_currencies: 'EUR',
      country_capital: 'Monaco',
    },
    {
      LCID: 'ro-MD',
      language_code: 'ro',
      language_name: 'Romanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'MD',
      country_name: 'Moldova',
      country_currencies: 'MDL',
      country_capital: 'Chișinău',
    },
    {
      LCID: 'sr-ME',
      language_code: 'sr',
      language_name: 'Serbian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ME',
      country_name: 'Montenegro',
      country_currencies: 'EUR',
      country_capital: 'Podgorica',
    },
    {
      LCID: 'bs-ME',
      language_code: 'bs',
      language_name: 'Bosnian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ME',
      country_name: 'Montenegro',
      country_currencies: 'EUR',
      country_capital: 'Podgorica',
    },
    {
      LCID: 'sq-ME',
      language_code: 'sq',
      language_name: 'Albanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ME',
      country_name: 'Montenegro',
      country_currencies: 'EUR',
      country_capital: 'Podgorica',
    },
    {
      LCID: 'hr-ME',
      language_code: 'hr',
      language_name: 'Croatian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'ME',
      country_name: 'Montenegro',
      country_currencies: 'EUR',
      country_capital: 'Podgorica',
    },
    {
      LCID: 'en-MF',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MF',
      country_name: 'Saint Martin',
      country_currencies: 'EUR',
      country_capital: 'Marigot',
    },
    {
      LCID: 'fr-MF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MF',
      country_name: 'Saint Martin',
      country_currencies: 'EUR',
      country_capital: 'Marigot',
    },
    {
      LCID: 'nl-MF',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MF',
      country_name: 'Saint Martin',
      country_currencies: 'EUR',
      country_capital: 'Marigot',
    },
    {
      LCID: 'fr-MG',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MG',
      country_name: 'Madagascar',
      country_currencies: 'MGA',
      country_capital: 'Antananarivo',
    },
    {
      LCID: 'mg-MG',
      language_code: 'mg',
      language_name: 'Malagasy',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MG',
      country_name: 'Madagascar',
      country_currencies: 'MGA',
      country_capital: 'Antananarivo',
    },
    {
      LCID: 'en-MH',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'MH',
      country_name: 'Marshall Islands',
      country_currencies: 'USD',
      country_capital: 'Majuro',
    },
    {
      LCID: 'mh-MH',
      language_code: 'mh',
      language_name: 'Marshallese',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'MH',
      country_name: 'Marshall Islands',
      country_currencies: 'USD',
      country_capital: 'Majuro',
    },
    {
      LCID: 'mk-MK',
      language_code: 'mk',
      language_name: 'Macedonian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'MK',
      country_name: 'North Macedonia',
      country_currencies: 'MKD',
      country_capital: 'Skopje',
    },
    {
      LCID: 'fr-ML',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ML',
      country_name: 'Mali',
      country_currencies: 'XOF',
      country_capital: 'Bamako',
    },
    {
      LCID: 'my-MM',
      language_code: 'my',
      language_name: 'Burmese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MM',
      country_name: 'Myanmar [Burma]',
      country_currencies: 'MMK',
      country_capital: 'Naypyidaw',
    },
    {
      LCID: 'mn-MN',
      language_code: 'mn',
      language_name: 'Mongolian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MN',
      country_name: 'Mongolia',
      country_currencies: 'MNT',
      country_capital: 'Ulan Bator',
    },
    {
      LCID: 'zh-MO',
      language_code: 'zh',
      language_name: 'Chinese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MO',
      country_name: 'Macao',
      country_currencies: 'MOP',
      country_capital: '',
    },
    {
      LCID: 'pt-MO',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MO',
      country_name: 'Macao',
      country_currencies: 'MOP',
      country_capital: '',
    },
    {
      LCID: 'en-MP',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'MP',
      country_name: 'Northern Mariana Islands',
      country_currencies: 'USD',
      country_capital: 'Saipan',
    },
    {
      LCID: 'ch-MP',
      language_code: 'ch',
      language_name: 'Chamorro',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'MP',
      country_name: 'Northern Mariana Islands',
      country_currencies: 'USD',
      country_capital: 'Saipan',
    },
    {
      LCID: 'fr-MQ',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MQ',
      country_name: 'Martinique',
      country_currencies: 'EUR',
      country_capital: 'Fort-de-France',
    },
    {
      LCID: 'ar-MR',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MR',
      country_name: 'Mauritania',
      country_currencies: 'MRU',
      country_capital: 'Nouakchott',
    },
    {
      LCID: 'en-MS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MS',
      country_name: 'Montserrat',
      country_currencies: 'XCD',
      country_capital: 'Plymouth',
    },
    {
      LCID: 'mt-MT',
      language_code: 'mt',
      language_name: 'Maltese',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'MT',
      country_name: 'Malta',
      country_currencies: 'EUR',
      country_capital: 'Valletta',
    },
    {
      LCID: 'en-MT',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'MT',
      country_name: 'Malta',
      country_currencies: 'EUR',
      country_capital: 'Valletta',
    },
    {
      LCID: 'en-MU',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MU',
      country_name: 'Mauritius',
      country_currencies: 'MUR',
      country_capital: 'Port Louis',
    },
    {
      LCID: 'dv-MV',
      language_code: 'dv',
      language_name: 'Divehi',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MV',
      country_name: 'Maldives',
      country_currencies: 'MVR',
      country_capital: 'Malé',
    },
    {
      LCID: 'en-MW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MW',
      country_name: 'Malawi',
      country_currencies: 'MWK',
      country_capital: 'Lilongwe',
    },
    {
      LCID: 'ny-MW',
      language_code: 'ny',
      language_name: 'Chichewa',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MW',
      country_name: 'Malawi',
      country_currencies: 'MWK',
      country_capital: 'Lilongwe',
    },
    {
      LCID: 'es-MX',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'MX',
      country_name: 'Mexico',
      country_currencies: 'MXN',
      country_capital: 'Mexico City',
    },
    {
      LCID: 'ms-MY',
      language_code: 'ms',
      language_name: 'Malay',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'MY',
      country_name: 'Malaysia',
      country_currencies: 'MYR',
      country_capital: 'Kuala Lumpur',
    },
    {
      LCID: 'pt-MZ',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'MZ',
      country_name: 'Mozambique',
      country_currencies: 'MZN',
      country_capital: 'Maputo',
    },
    {
      LCID: 'en-NA',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'NA',
      country_name: 'Namibia',
      country_currencies: 'NAD,ZAR',
      country_capital: 'Windhoek',
    },
    {
      LCID: 'af-NA',
      language_code: 'af',
      language_name: 'Afrikaans',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'NA',
      country_name: 'Namibia',
      country_currencies: 'NAD,ZAR',
      country_capital: 'Windhoek',
    },
    {
      LCID: 'fr-NC',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NC',
      country_name: 'New Caledonia',
      country_currencies: 'XPF',
      country_capital: 'Nouméa',
    },
    {
      LCID: 'fr-NE',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'NE',
      country_name: 'Niger',
      country_currencies: 'XOF',
      country_capital: 'Niamey',
    },
    {
      LCID: 'en-NF',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NF',
      country_name: 'Norfolk Island',
      country_currencies: 'AUD',
      country_capital: 'Kingston',
    },
    {
      LCID: 'en-NG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'NG',
      country_name: 'Nigeria',
      country_currencies: 'NGN',
      country_capital: 'Abuja',
    },
    {
      LCID: 'es-NI',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'NI',
      country_name: 'Nicaragua',
      country_currencies: 'NIO',
      country_capital: 'Managua',
    },
    {
      LCID: 'nl-NL',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'NL',
      country_name: 'Netherlands',
      country_currencies: 'EUR',
      country_capital: 'Amsterdam',
    },
    {
      LCID: 'no-NO',
      language_code: 'no',
      language_name: 'Norwegian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'NO',
      country_name: 'Norway',
      country_currencies: 'NOK',
      country_capital: 'Oslo',
    },
    {
      LCID: 'nb-NO',
      language_code: 'nb',
      language_name: 'Norwegian Bokmål',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'NO',
      country_name: 'Norway',
      country_currencies: 'NOK',
      country_capital: 'Oslo',
    },
    {
      LCID: 'nn-NO',
      language_code: 'nn',
      language_name: 'Norwegian Nynorsk',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'NO',
      country_name: 'Norway',
      country_currencies: 'NOK',
      country_capital: 'Oslo',
    },
    {
      LCID: 'ne-NP',
      language_code: 'ne',
      language_name: 'Nepali',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'NP',
      country_name: 'Nepal',
      country_currencies: 'NPR',
      country_capital: 'Kathmandu',
    },
    {
      LCID: 'en-NR',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NR',
      country_name: 'Nauru',
      country_currencies: 'AUD',
      country_capital: 'Yaren',
    },
    {
      LCID: 'na-NR',
      language_code: 'na',
      language_name: 'Nauruan',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NR',
      country_name: 'Nauru',
      country_currencies: 'AUD',
      country_capital: 'Yaren',
    },
    {
      LCID: 'en-NU',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NU',
      country_name: 'Niue',
      country_currencies: 'NZD',
      country_capital: 'Alofi',
    },
    {
      LCID: 'en-NZ',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NZ',
      country_name: 'New Zealand',
      country_currencies: 'NZD',
      country_capital: 'Wellington',
    },
    {
      LCID: 'mi-NZ',
      language_code: 'mi',
      language_name: 'Maori',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'NZ',
      country_name: 'New Zealand',
      country_currencies: 'NZD',
      country_capital: 'Wellington',
    },
    {
      LCID: 'ar-OM',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'OM',
      country_name: 'Oman',
      country_currencies: 'OMR',
      country_capital: 'Muscat',
    },
    {
      LCID: 'es-PA',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'PA',
      country_name: 'Panama',
      country_currencies: 'PAB,USD',
      country_capital: 'Panama City',
    },
    {
      LCID: 'es-PE',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'PE',
      country_name: 'Peru',
      country_currencies: 'PEN',
      country_capital: 'Lima',
    },
    {
      LCID: 'fr-PF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'PF',
      country_name: 'French Polynesia',
      country_currencies: 'XPF',
      country_capital: 'Papeetē',
    },
    {
      LCID: 'en-PG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'PG',
      country_name: 'Papua New Guinea',
      country_currencies: 'PGK',
      country_capital: 'Port Moresby',
    },
    {
      LCID: 'en-PH',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'PH',
      country_name: 'Philippines',
      country_currencies: 'PHP',
      country_capital: 'Manila',
    },
    {
      LCID: 'en-PK',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'PK',
      country_name: 'Pakistan',
      country_currencies: 'PKR',
      country_capital: 'Islamabad',
    },
    {
      LCID: 'ur-PK',
      language_code: 'ur',
      language_name: 'Urdu',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'PK',
      country_name: 'Pakistan',
      country_currencies: 'PKR',
      country_capital: 'Islamabad',
    },
    {
      LCID: 'pl-PL',
      language_code: 'pl',
      language_name: 'Polish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'PL',
      country_name: 'Poland',
      country_currencies: 'PLN',
      country_capital: 'Warsaw',
    },
    {
      LCID: 'fr-PM',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'PM',
      country_name: 'Saint Pierre and Miquelon',
      country_currencies: 'EUR',
      country_capital: 'Saint-Pierre',
    },
    {
      LCID: 'en-PN',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'PN',
      country_name: 'Pitcairn Islands',
      country_currencies: 'NZD',
      country_capital: 'Adamstown',
    },
    {
      LCID: 'es-PR',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'PR',
      country_name: 'Puerto Rico',
      country_currencies: 'USD',
      country_capital: 'San Juan',
    },
    {
      LCID: 'en-PR',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'PR',
      country_name: 'Puerto Rico',
      country_currencies: 'USD',
      country_capital: 'San Juan',
    },
    {
      LCID: 'ar-PS',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'PS',
      country_name: 'Palestine',
      country_currencies: 'ILS',
      country_capital: 'Ramallah',
    },
    {
      LCID: 'pt-PT',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'PT',
      country_name: 'Portugal',
      country_currencies: 'EUR',
      country_capital: 'Lisbon',
    },
    {
      LCID: 'en-PW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'PW',
      country_name: 'Palau',
      country_currencies: 'USD',
      country_capital: 'Ngerulmud',
    },
    {
      LCID: 'es-PY',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'PY',
      country_name: 'Paraguay',
      country_currencies: 'PYG',
      country_capital: 'Asunción',
    },
    {
      LCID: 'gn-PY',
      language_code: 'gn',
      language_name: 'Guarani',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'PY',
      country_name: 'Paraguay',
      country_currencies: 'PYG',
      country_capital: 'Asunción',
    },
    {
      LCID: 'ar-QA',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'QA',
      country_name: 'Qatar',
      country_currencies: 'QAR',
      country_capital: 'Doha',
    },
    {
      LCID: 'fr-RE',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'RE',
      country_name: 'Réunion',
      country_currencies: 'EUR',
      country_capital: 'Saint-Denis',
    },
    {
      LCID: 'ro-RO',
      language_code: 'ro',
      language_name: 'Romanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'RO',
      country_name: 'Romania',
      country_currencies: 'RON',
      country_capital: 'Bucharest',
    },
    {
      LCID: 'sr-RS',
      language_code: 'sr',
      language_name: 'Serbian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'RS',
      country_name: 'Serbia',
      country_currencies: 'RSD',
      country_capital: 'Belgrade',
    },
    {
      LCID: 'ru-RU',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'RU',
      country_name: 'Russia',
      country_currencies: 'RUB',
      country_capital: 'Moscow',
    },
    {
      LCID: 'rw-RW',
      language_code: 'rw',
      language_name: 'Rwandi',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'RW',
      country_name: 'Rwanda',
      country_currencies: 'RWF',
      country_capital: 'Kigali',
    },
    {
      LCID: 'en-RW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'RW',
      country_name: 'Rwanda',
      country_currencies: 'RWF',
      country_capital: 'Kigali',
    },
    {
      LCID: 'fr-RW',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'RW',
      country_name: 'Rwanda',
      country_currencies: 'RWF',
      country_capital: 'Kigali',
    },
    {
      LCID: 'ar-SA',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SA',
      country_name: 'Saudi Arabia',
      country_currencies: 'SAR',
      country_capital: 'Riyadh',
    },
    {
      LCID: 'en-SB',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'SB',
      country_name: 'Solomon Islands',
      country_currencies: 'SBD',
      country_capital: 'Honiara',
    },
    {
      LCID: 'fr-SC',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SC',
      country_name: 'Seychelles',
      country_currencies: 'SCR',
      country_capital: 'Victoria',
    },
    {
      LCID: 'en-SC',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SC',
      country_name: 'Seychelles',
      country_currencies: 'SCR',
      country_capital: 'Victoria',
    },
    {
      LCID: 'ar-SD',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SD',
      country_name: 'Sudan',
      country_currencies: 'SDG',
      country_capital: 'Khartoum',
    },
    {
      LCID: 'en-SD',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SD',
      country_name: 'Sudan',
      country_currencies: 'SDG',
      country_capital: 'Khartoum',
    },
    {
      LCID: 'sv-SE',
      language_code: 'sv',
      language_name: 'Swedish',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'SE',
      country_name: 'Sweden',
      country_currencies: 'SEK',
      country_capital: 'Stockholm',
    },
    {
      LCID: 'en-SG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SG',
      country_name: 'Singapore',
      country_currencies: 'SGD',
      country_capital: 'Singapore',
    },
    {
      LCID: 'ms-SG',
      language_code: 'ms',
      language_name: 'Malay',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SG',
      country_name: 'Singapore',
      country_currencies: 'SGD',
      country_capital: 'Singapore',
    },
    {
      LCID: 'ta-SG',
      language_code: 'ta',
      language_name: 'Tamil',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SG',
      country_name: 'Singapore',
      country_currencies: 'SGD',
      country_capital: 'Singapore',
    },
    {
      LCID: 'zh-SG',
      language_code: 'zh',
      language_name: 'Chinese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SG',
      country_name: 'Singapore',
      country_currencies: 'SGD',
      country_capital: 'Singapore',
    },
    {
      LCID: 'en-SH',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SH',
      country_name: 'Saint Helena',
      country_currencies: 'SHP',
      country_capital: 'Jamestown',
    },
    {
      LCID: 'sl-SI',
      language_code: 'sl',
      language_name: 'Slovenian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'SI',
      country_name: 'Slovenia',
      country_currencies: 'EUR',
      country_capital: 'Ljubljana',
    },
    {
      LCID: 'no-SJ',
      language_code: 'no',
      language_name: 'Norwegian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'SJ',
      country_name: 'Svalbard and Jan Mayen',
      country_currencies: 'NOK',
      country_capital: 'Longyearbyen',
    },
    {
      LCID: 'sk-SK',
      language_code: 'sk',
      language_name: 'Slovak',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'SK',
      country_name: 'Slovakia',
      country_currencies: 'EUR',
      country_capital: 'Bratislava',
    },
    {
      LCID: 'en-SL',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SL',
      country_name: 'Sierra Leone',
      country_currencies: 'SLL',
      country_capital: 'Freetown',
    },
    {
      LCID: 'it-SM',
      language_code: 'it',
      language_name: 'Italian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'SM',
      country_name: 'San Marino',
      country_currencies: 'EUR',
      country_capital: 'City of San Marino',
    },
    {
      LCID: 'fr-SN',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SN',
      country_name: 'Senegal',
      country_currencies: 'XOF',
      country_capital: 'Dakar',
    },
    {
      LCID: 'so-SO',
      language_code: 'so',
      language_name: 'Somalia',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SO',
      country_name: 'Somalia',
      country_currencies: 'SOS',
      country_capital: 'Mogadishu',
    },
    {
      LCID: 'ar-SO',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SO',
      country_name: 'Somalia',
      country_currencies: 'SOS',
      country_capital: 'Mogadishu',
    },
    {
      LCID: 'nl-SR',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'SR',
      country_name: 'Suriname',
      country_currencies: 'SRD',
      country_capital: 'Paramaribo',
    },
    {
      LCID: 'en-SS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SS',
      country_name: 'South Sudan',
      country_currencies: 'SSP',
      country_capital: 'Juba',
    },
    {
      LCID: 'pt-ST',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ST',
      country_name: 'São Tomé and Príncipe',
      country_currencies: 'STN',
      country_capital: 'São Tomé',
    },
    {
      LCID: 'es-SV',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'SV',
      country_name: 'El Salvador',
      country_currencies: 'SVC,USD',
      country_capital: 'San Salvador',
    },
    {
      LCID: 'nl-SX',
      language_code: 'nl',
      language_name: 'Dutch',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'SX',
      country_name: 'Sint Maarten',
      country_currencies: 'ANG',
      country_capital: 'Philipsburg',
    },
    {
      LCID: 'en-SX',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'SX',
      country_name: 'Sint Maarten',
      country_currencies: 'ANG',
      country_capital: 'Philipsburg',
    },
    {
      LCID: 'ar-SY',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'SY',
      country_name: 'Syria',
      country_currencies: 'SYP',
      country_capital: 'Damascus',
    },
    {
      LCID: 'en-SZ',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SZ',
      country_name: 'Swaziland',
      country_currencies: 'SZL',
      country_capital: 'Lobamba',
    },
    {
      LCID: 'ss-SZ',
      language_code: 'ss',
      language_name: 'Swati',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'SZ',
      country_name: 'Swaziland',
      country_currencies: 'SZL',
      country_capital: 'Lobamba',
    },
    {
      LCID: 'en-TC',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'TC',
      country_name: 'Turks and Caicos Islands',
      country_currencies: 'USD',
      country_capital: 'Cockburn Town',
    },
    {
      LCID: 'fr-TD',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TD',
      country_name: 'Chad',
      country_currencies: 'XAF',
      country_capital: "N'Djamena",
    },
    {
      LCID: 'ar-TD',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TD',
      country_name: 'Chad',
      country_currencies: 'XAF',
      country_capital: "N'Djamena",
    },
    {
      LCID: 'fr-TF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AN',
      continent_name: 'Antarctica',
      country_code: 'TF',
      country_name: 'French Southern Territories',
      country_currencies: 'EUR',
      country_capital: 'Port-aux-Français',
    },
    {
      LCID: 'fr-TG',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TG',
      country_name: 'Togo',
      country_currencies: 'XOF',
      country_capital: 'Lomé',
    },
    {
      LCID: 'th-TH',
      language_code: 'th',
      language_name: 'Thai',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TH',
      country_name: 'Thailand',
      country_currencies: 'THB',
      country_capital: 'Bangkok',
    },
    {
      LCID: 'tg-TJ',
      language_code: 'tg',
      language_name: 'Tajik',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TJ',
      country_name: 'Tajikistan',
      country_currencies: 'TJS',
      country_capital: 'Dushanbe',
    },
    {
      LCID: 'ru-TJ',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TJ',
      country_name: 'Tajikistan',
      country_currencies: 'TJS',
      country_capital: 'Dushanbe',
    },
    {
      LCID: 'en-TK',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'TK',
      country_name: 'Tokelau',
      country_currencies: 'NZD',
      country_capital: 'Fakaofo',
    },
    {
      LCID: 'pt-TL',
      language_code: 'pt',
      language_name: 'Portuguese',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'TL',
      country_name: 'East Timor',
      country_currencies: 'USD',
      country_capital: 'Dili',
    },
    {
      LCID: 'tk-TM',
      language_code: 'tk',
      language_name: 'Turkmen',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TM',
      country_name: 'Turkmenistan',
      country_currencies: 'TMT',
      country_capital: 'Ashgabat',
    },
    {
      LCID: 'ru-TM',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TM',
      country_name: 'Turkmenistan',
      country_currencies: 'TMT',
      country_capital: 'Ashgabat',
    },
    {
      LCID: 'ar-TN',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TN',
      country_name: 'Tunisia',
      country_currencies: 'TND',
      country_capital: 'Tunis',
    },
    {
      LCID: 'en-TO',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'TO',
      country_name: 'Tonga',
      country_currencies: 'TOP',
      country_capital: "Nuku'alofa",
    },
    {
      LCID: 'to-TO',
      language_code: 'to',
      language_name: 'Tonga',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'TO',
      country_name: 'Tonga',
      country_currencies: 'TOP',
      country_capital: "Nuku'alofa",
    },
    {
      LCID: 'tr-TR',
      language_code: 'tr',
      language_name: 'Turkish',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TR',
      country_name: 'Turkey',
      country_currencies: 'TRY',
      country_capital: 'Ankara',
    },
    {
      LCID: 'en-TT',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'TT',
      country_name: 'Trinidad and Tobago',
      country_currencies: 'TTD',
      country_capital: 'Port of Spain',
    },
    {
      LCID: 'en-TV',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'TV',
      country_name: 'Tuvalu',
      country_currencies: 'AUD',
      country_capital: 'Funafuti',
    },
    {
      LCID: 'zh-TW',
      language_code: 'zh',
      language_name: 'Chinese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'TW',
      country_name: 'Taiwan',
      country_currencies: 'TWD',
      country_capital: 'Taipei',
    },
    {
      LCID: 'sw-TZ',
      language_code: 'sw',
      language_name: 'Swahili',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TZ',
      country_name: 'Tanzania',
      country_currencies: 'TZS',
      country_capital: 'Dodoma',
    },
    {
      LCID: 'en-TZ',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'TZ',
      country_name: 'Tanzania',
      country_currencies: 'TZS',
      country_capital: 'Dodoma',
    },
    {
      LCID: 'uk-UA',
      language_code: 'uk',
      language_name: 'Ukrainian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'UA',
      country_name: 'Ukraine',
      country_currencies: 'UAH',
      country_capital: 'Kyiv',
    },
    {
      LCID: 'en-UG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'UG',
      country_name: 'Uganda',
      country_currencies: 'UGX',
      country_capital: 'Kampala',
    },
    {
      LCID: 'sw-UG',
      language_code: 'sw',
      language_name: 'Swahili',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'UG',
      country_name: 'Uganda',
      country_currencies: 'UGX',
      country_capital: 'Kampala',
    },
    {
      LCID: 'en-UM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'UM',
      country_name: 'U.S. Minor Outlying Islands',
      country_currencies: 'USD',
      country_capital: '',
    },
    {
      LCID: 'en-US',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'US',
      country_name: 'United States',
      country_currencies: 'USD,USN,USS',
      country_capital: 'Washington D.C.',
    },
    {
      LCID: 'es-UY',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'UY',
      country_name: 'Uruguay',
      country_currencies: 'UYI,UYU',
      country_capital: 'Montevideo',
    },
    {
      LCID: 'uz-UZ',
      language_code: 'uz',
      language_name: 'Uzbek',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'UZ',
      country_name: 'Uzbekistan',
      country_currencies: 'UZS',
      country_capital: 'Tashkent',
    },
    {
      LCID: 'ru-UZ',
      language_code: 'ru',
      language_name: 'Russian',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'UZ',
      country_name: 'Uzbekistan',
      country_currencies: 'UZS',
      country_capital: 'Tashkent',
    },
    {
      LCID: 'it-VA',
      language_code: 'it',
      language_name: 'Italian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'VA',
      country_name: 'Vatican City',
      country_currencies: 'EUR',
      country_capital: 'Vatican City',
    },
    {
      LCID: 'la-VA',
      language_code: 'la',
      language_name: 'Latin',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'VA',
      country_name: 'Vatican City',
      country_currencies: 'EUR',
      country_capital: 'Vatican City',
    },
    {
      LCID: 'en-VC',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'VC',
      country_name: 'Saint Vincent and the Grenadines',
      country_currencies: 'XCD',
      country_capital: 'Kingstown',
    },
    {
      LCID: 'es-VE',
      language_code: 'es',
      language_name: 'Spanish',
      continent_code: 'SA',
      continent_name: 'South America',
      country_code: 'VE',
      country_name: 'Venezuela',
      country_currencies: 'VES',
      country_capital: 'Caracas',
    },
    {
      LCID: 'en-VG',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'VG',
      country_name: 'British Virgin Islands',
      country_currencies: 'USD',
      country_capital: 'Road Town',
    },
    {
      LCID: 'en-VI',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'NA',
      continent_name: 'North America',
      country_code: 'VI',
      country_name: 'U.S. Virgin Islands',
      country_currencies: 'USD',
      country_capital: 'Charlotte Amalie',
    },
    {
      LCID: 'vi-VN',
      language_code: 'vi',
      language_name: 'Vietnamese',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'VN',
      country_name: 'Vietnam',
      country_currencies: 'VND',
      country_capital: 'Hanoi',
    },
    {
      LCID: 'bi-VU',
      language_code: 'bi',
      language_name: 'Bislama',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'VU',
      country_name: 'Vanuatu',
      country_currencies: 'VUV',
      country_capital: 'Port Vila',
    },
    {
      LCID: 'en-VU',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'VU',
      country_name: 'Vanuatu',
      country_currencies: 'VUV',
      country_capital: 'Port Vila',
    },
    {
      LCID: 'fr-VU',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'VU',
      country_name: 'Vanuatu',
      country_currencies: 'VUV',
      country_capital: 'Port Vila',
    },
    {
      LCID: 'fr-WF',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'WF',
      country_name: 'Wallis and Futuna',
      country_currencies: 'XPF',
      country_capital: 'Mata-Utu',
    },
    {
      LCID: 'sm-WS',
      language_code: 'sm',
      language_name: 'Samoan',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'WS',
      country_name: 'Samoa',
      country_currencies: 'WST',
      country_capital: 'Apia',
    },
    {
      LCID: 'en-WS',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'OC',
      continent_name: 'Oceania',
      country_code: 'WS',
      country_name: 'Samoa',
      country_currencies: 'WST',
      country_capital: 'Apia',
    },
    {
      LCID: 'sq-XK',
      language_code: 'sq',
      language_name: 'Albanian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'XK',
      country_name: 'Kosovo',
      country_currencies: 'EUR',
      country_capital: 'Pristina',
    },
    {
      LCID: 'sr-XK',
      language_code: 'sr',
      language_name: 'Serbian',
      continent_code: 'EU',
      continent_name: 'Europe',
      country_code: 'XK',
      country_name: 'Kosovo',
      country_currencies: 'EUR',
      country_capital: 'Pristina',
    },
    {
      LCID: 'ar-YE',
      language_code: 'ar',
      language_name: 'Arabic',
      continent_code: 'AS',
      continent_name: 'Asia',
      country_code: 'YE',
      country_name: 'Yemen',
      country_currencies: 'YER',
      country_capital: "Sana'a",
    },
    {
      LCID: 'fr-YT',
      language_code: 'fr',
      language_name: 'French',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'YT',
      country_name: 'Mayotte',
      country_currencies: 'EUR',
      country_capital: 'Mamoudzou',
    },
    {
      LCID: 'af-ZA',
      language_code: 'af',
      language_name: 'Afrikaans',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'en-ZA',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'nr-ZA',
      language_code: 'nr',
      language_name: 'South Ndebele',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'st-ZA',
      language_code: 'st',
      language_name: 'Southern Sotho',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'ss-ZA',
      language_code: 'ss',
      language_name: 'Swati',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'tn-ZA',
      language_code: 'tn',
      language_name: 'Tswana',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'ts-ZA',
      language_code: 'ts',
      language_name: 'Tsonga',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 've-ZA',
      language_code: 've',
      language_name: 'Venda',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'xh-ZA',
      language_code: 'xh',
      language_name: 'Xhosa',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'zu-ZA',
      language_code: 'zu',
      language_name: 'Zulu',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZA',
      country_name: 'South Africa',
      country_currencies: 'ZAR',
      country_capital: 'Pretoria',
    },
    {
      LCID: 'en-ZM',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZM',
      country_name: 'Zambia',
      country_currencies: 'ZMW',
      country_capital: 'Lusaka',
    },
    {
      LCID: 'en-ZW',
      language_code: 'en',
      language_name: 'English',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZW',
      country_name: 'Zimbabwe',
      country_currencies: 'USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY',
      country_capital: 'Harare',
    },
    {
      LCID: 'sn-ZW',
      language_code: 'sn',
      language_name: 'Shona',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZW',
      country_name: 'Zimbabwe',
      country_currencies: 'USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY',
      country_capital: 'Harare',
    },
    {
      LCID: 'nd-ZW',
      language_code: 'nd',
      language_name: 'North Ndebele',
      continent_code: 'AF',
      continent_name: 'Africa',
      country_code: 'ZW',
      country_name: 'Zimbabwe',
      country_currencies: 'USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY',
      country_capital: 'Harare',
    },
  ],
};
